<sk-modal-content [title]="'label.Translations' | translate"
                  [cancelBtnText]="'label.Close'"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <div class="source-box disabled">
      <ng-container
        [ngTemplateOutlet]="controlTemplate"
        [ngTemplateOutletContext]="{ $implicit: originalFieldControl, label: 'label.Source', modal: true }"
      ></ng-container>
    </div>
    @if (languagesForm) {
      <form [formGroup]="languagesForm">
        @for (language of languages; track language.name) {
          <div class="flex-row flex-middle">
              <ng-container
                [ngTemplateOutlet]="controlTemplate"
                [ngTemplateOutletContext]="{ $implicit: languagesForm.get(language.name), label: 'label.' + language.name, modal: true }"
              ></ng-container>
            @if (enableTranslations) {
              <sk-button size="m"
                         appearance="icon"
                         class="ms-2"
                         data-test="translate-one-btn"
                         [matTooltip]="'label.Translate' | translate"
                         (click)="translateOne(language.name)">
                <ng-template buttonPrefix>
                  <i class="icon fas fa-language"></i>
                </ng-template>
              </sk-button>
            }
          </div>
        }
      </form>
    } @else {
      <iris-simple-loader></iris-simple-loader>
    }
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      data-test="modal-footer-confirm-button"
      (click)="accept()"
      [label]="'label.Save' | translate"
      [disabled]="!languagesForm?.valid"
    >
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>

</sk-modal-content>
